import { Modal as MUIModal, Box, Stack } from '@mui/material'
import zIndex from '@mui/material/styles/zIndex'

function Modal({
  open,
  onClose,
  children,
  sx,
  rootSx,
  ...rest
}: {
  open: boolean
  onClose: () => void
  children?: React.ReactNode
  sx?: Any
  rootSx?: Any
}) {
  const style = {
    bgcolor: '#52525d90',
    border: '0.5px solid #6c6c79',
    p: 2,
    boxShadow: '0px 9px 25.8px 0px #00000026',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'calc(100% - 10%)',
    maxHeight: 'calc(100% - 10%)',
    borderRadius: 5,
  }

  const gradientStyleAfter = {
    width: 800,
    height: 800,
    content: '""',
    position: 'absolute',
    left: '40%',
    top: '-40%',
    background: 'radial-gradient(circle, #032f12 0%, rgba(252,70,70,0) 80%)',
    zIndex: -1,
    borderRadius: '100%',
  }
  const gradientStyleBefore = {
    width: 800,
    height: 800,
    content: '""',
    position: 'absolute',
    left: '10%',
    top: '-50%',
    background: 'radial-gradient(circle, #807727 0%, rgba(252,70,70,0) 80%)',
    zIndex: -1,
    borderRadius: '100%',
  }

  return (
    <MUIModal
      open={open}
      onClose={onClose}
      sx={sx}
      {...rest}
      slotProps={{
        backdrop: { sx: { backdropFilter: 'blur(7px)' } },
        root: {
          sx: {
            ...rootSx,
            '&::after': gradientStyleAfter,
            '&:before': gradientStyleBefore,
          },
        },
      }}
    >
      <Stack minHeight="100vh" alignItems="center" justifyContent="center">
        <Box sx={style}>{children}</Box>
      </Stack>
    </MUIModal>
  )
}

export default Modal
